import React from "react";
import { Button, CircularProgress, Select, MenuItem, OutlinedInput, IconButton, FormControl, InputLabel, FormHelperText } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import CreateRoleDialog from "./Forms/CreateRoleDialogForm";
import { getPermissionDescription } from "./Forms/Permissions";

function RolesDropdown({ value, handleChange, roles, onRoleCreate, onRoleDelete, loadingRoles }) {
    const [roleToEdit, setRoleToEdit] = React.useState(null);
    const [isCreateOpen, setIsCreateOpen] = React.useState(false);

    return (
        <React.Fragment>
            {false && <InputLabel>Role</InputLabel>}
            <Select
                name="role_id"
                fullWidth
                placeholder="test"
                displayEmpty
                input={
                    <OutlinedInput />
                }
                value={value}
                onChange={handleChange}
                style={{
                    marginBottom: 10,
                    // minHeight:
                }}
            >
                <MenuItem className="role_item" value="" disabled>
                    Select a Role
                    <div style={{ height: 37 }}></div>
                </MenuItem>                {
                    roles.map(role => {
                        const isRoleLoading = loadingRoles.includes(role.id);
                        const style = {};
                        if (role.is_read_only == "1") {
                            style.visibility = "hidden";
                        }
                        let roleDescription = "";
                        if (role.type == 1) {
                            roleDescription = "Has access to everything";
                        } else if (role.type == 2) {
                            roleDescription = "can view, add and edit data but cannot invite other users nor modify fields";
                        } else {
                            roleDescription = getPermissionDescription(role);
                            // roleDescription = "Set your own custom permissions"
                        }

                        return <MenuItem key={role.id} value={role["id"]} className="role_item">
                            <div>
                                {role.name}
                                <div className="role_description">{roleDescription}</div>
                            </div>
                            <div style={{ display: "inline-block" }}>
                                <IconButton
                                    className="role_action_buttons"
                                    style={style}
                                    disabled={isRoleLoading}
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        ev.preventDefault();
                                        setRoleToEdit(role);
                                        setIsCreateOpen(true);
                                    }}
                                >
                                    <EditIcon style={{
                                        fontSize: 12,
                                    }} />

                                </IconButton>
                                <IconButton
                                    className="role_action_buttons"
                                    style={style}
                                    disabled={isRoleLoading}
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        ev.preventDefault();
                                        onRoleDelete(role);
                                    }}
                                >
                                    {isRoleLoading
                                        ? <CircularProgress size={20} />
                                        : <CloseIcon style={{
                                            fontSize: 12,
                                        }} />
                                    }
                                </IconButton>
                            </div>
                        </MenuItem>
                    })
                }
                <hr />
                <MenuItem value="create_role" >
                    <div onClick={(ev) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        setRoleToEdit(null);
                        setIsCreateOpen(true);
                    }}>
                        Create New Role...
                        <div className="role_description">Set your own custom permissions</div>
                    </div>
                </MenuItem>
            </Select>
            {
                isCreateOpen && <CreateRoleDialog open={isCreateOpen} role={roleToEdit} onCreate={onRoleCreate} onClose={() => {
                    setIsCreateOpen(false)
                    if (!value) {
                        handleChange({ target: { value: roles[roles.length - 1].id, name: "role" } })
                    }
                }} />
            }
        </React.Fragment>
    )
}

export default RolesDropdown;